import * as React from 'react';
import { SVGProps } from 'react';

const SvgDiabetesDiaryOputlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4c1.306 0 2.418.835 2.83 2H16a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h2Zm4 4h-6a2 2 0 0 0-1.995 1.85L8 10v6a2 2 0 0 0 1.85 1.994L10 18h6a2 2 0 0 0 1.994-1.85L18 16v-6a2 2 0 0 0-2-2ZM5 15v2H4a1 1 0 1 1 0-2h1Zm0-3v2H4a1 1 0 1 1 0-2h1Zm0-3v2H4a1 1 0 1 1 0-2h1Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1ZM17 13a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1ZM17 16a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDiabetesDiaryOputlined;
